module.exports = __webpack_public_path__ + "static/media/8.0567c5a9.png";